export const styles = {
    searchBoxContainer: {
        position: "relative",
        //width: "240px",
        display: "flex",
        zIndex: 10,
        "&.is-mobile-version": {
            "&.opened": {
                position: "fixed",
                zIndex: 1000,
                left: 0,
                right: 0,
                top: 0,
                width: "100%",
                bottom: "65px",
                backgroundColor: "#EEEEEE",
                borderRadius: 0,
                "> .input-group": {
                    maxHeight: "32px"
                }
            },
            ".resultsBox": {
                maxHeight: "inherit",
                height: "100%"
            },
            ".resultsBoxContainer": {
                bottom: 0
            }
        },

        "&.opened": {
            width: "414px",
            backgroundColor: "#EEEEEE",
            padding: "12px",
            position: "absolute",
            right: "15px",
            top: "10px",
            borderRadius: "8px 8px 0 0",
            ".results-box": {
                top: "39px"
            },
            ".search-box": {
                borderRadius: "4px"
            },
            ".search-icon": {
                borderRadius: "4px 0 0 4px",
                height: "40px"
            }
        }
    },
    overlay: {
        position: "fixed",
        opacity: "0.5",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
        backgroundColor: "#111111"
    },
    searchBox: {
        backgroundColor: "#FFFFFF",
        position: "relative",
        flexGrow: 1,
        borderRadius: "0 4px 4px 0"
    },
    searchIcon: {
        display: "flex",
        alignItems: "center",
        color: "#111111",
        padding: "0 10px",
        backgroundColor: "#FFFFFF",
        margin: 0,
        borderRadius: "4px",
        fontSize: "14px"
    },
    inputGroup: {
        display: "flex",
        flexGrow: 1,
        height: "40px",
        border: "1px solid #EEEEEE",
        borderRadius: "4px"
    },
    searchBoxInput: {
        backgroundColor: "#FFFFFF",
        color: "#111111",
        fontSize: "14px",
        border: "none",
        width: "100%",
        height: "40px",
        padding: "0 10px 0 0",
        borderRadius: "0 4px 4px 0",
        "&:focus": {
            border: "none",
            boxShadow: "none"
        },
        "&:hover": {
            border: "none"
        },
        "&::placeholder": {
            color: "#111111",
            opacity: 1
        },
        "::after, ::before": {
            border: "none !important",
            transition: "none"
        }
    },
    clearSearchStringBtn: {
        position: "absolute",
        top: "8px",
        right: "5px",
        color: "#111111",
        textShadow: "none",
        opacity: 1,
        fontSize: "20px",
        padding: "0",
        minWidth: "25px",
        "&:focus": {
            outline: "none"
        },
        "&:hover": {
            border: "none",
            backgroundColor: "transparent"
        }
    },
    resultsBox: {
        overflowY: "auto",
        height: "500px",
        padding: "0 12px",
        "&::-webkit-scrollbar": {
            width: "3px"
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#fff"
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#CBCBCB",
            borderRadius: "4px"
        }
    },
    gameResults: {
        paddingBottom: "12px",
        "&.no-results": {
            padding: "0"
        },
        ".gameSelectorTitle": {
            display: "none"
        },
        //section to be removed at later stage when new casino layout is implemented
        ".inner": {
            height: "100px",
            backgroundSize: "100% 100%",
            position: "relative",
            borderRadius: "8px",
            ".gameSelectorFooter": {
                position: "absolute",
                bottom: 0,
                right: 0,
                left: 0,
                textAlign: "center"
            },
            ".GamesButton": {
                position: "absolute",
                top: 0,
                bottom: 0,
                width: "100%",
                zIndex: 1,
                backgroundColor: "transparent"
            },
            ".host-add, .host-remove": {
                width: "20px",
                height: "20px",
                color: "#FFFFFF",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "16px",
                position: "relative",
                zIndex: 10,
                "&:hover": {
                    color: "#FFFFFF"
                }
            },
            "&:hover": {
                ".host-add, .host-remove": {
                    display: "flex !important"
                }
            },
            ".ribbon": {
                width: "50px",
                height: "50px",
                overflow: "hidden",
                position: "absolute"
            },

            ".ribbon::before, .ribbon::after": {
                position: "absolute",
                zIndex: "-1",
                content: "''",
                display: "block",
                border: "5px solid #2980b9"
            },

            ".ribbon span": {
                position: "absolute",
                display: "block",
                width: "85px",
                padding: "2px 0",
                backgroundColor: "#EC671C",
                boxShadow: "0 5px 10px rgba(0,0,0,.1)",
                color: "#fff",
                textShadow: "0 1px 1px rgba(0,0,0,.2)",
                textAlign: "center"
            },
            ".ribbon-top-right": {
                top: 0,
                right: 0
            },

            ".ribbon-top-right::before, .ribbon-top-right::after": {
                borderTopColor: "transparent",
                borderRightColor: "transparent"
            },

            ".ribbon-top-right::before": {
                top: 0,
                left: 0
            },

            ".ribbon-top-right::after": {
                bottom: 0,
                right: 0
            },

            ".ribbon-top-right span": {
                left: "-10px",
                top: "5px",
                transform: "rotate(45deg)"
            }
        }
    },
    headerText: {
        color: "#111111",
        fontSize: "16px",
        fontWeight: "bold",
        marginBottom: "10px",
        fontFamily: "Arial, sans-serif"
    },
    closeBtn: {
        color: "#111111",
        fontSize: "14px",
        border: "none",
        textTransform: "inherit",
        "&:focus": {
            outline: "none"
        },
        "&:hover": {
            border: "none",
            backgroundColor: "transparent"
        }
    },
    resultsBoxContainer: {
        position: "absolute",
        top: "64px",
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: "#EEEEEE"
    },
    resultsList: {
        display: "flex",
        flexWrap: "wrap"
    },
    noResultsImage: {
        backgroundImage: "url(clientApp/casino/SearchBox/Images/no-results.png)",
        width: "120px",
        height: "120px",
        backgroundPosition: "center center",
        backgroundRrepeat: "no-repeat",
        backgroundSize: "contain",
        margin: "0 auto"
    }
};